import { useState } from 'react';
import { Project, PROJECT_COLORS } from './types';

interface ProjectDialogProps {
  project?: Project;
  defaultColor: string;
  onClose: () => void;
  // eslint-disable-next-line no-unused-vars
  onSave: (values: { title: string; description: string; color: string }) => void;
}

function ProjectDialog({
  project, defaultColor, onClose, onSave,
}: ProjectDialogProps) {
  const [title, setTitle] = useState(project?.title ?? '');
  const [description, setDescription] = useState(project?.description ?? '');
  const [color, setColor] = useState(project?.color ?? defaultColor);
  const [titleError, setTitleError] = useState(false);

  const handleSave = () => {
    if (!title.trim()) {
      setTitleError(true);
      return;
    }
    onSave({ title: title.trim(), description: description.trim(), color });
  };

  return (
    <div
      className="hh-modal-backdrop"
      role="button"
      tabIndex={-1}
      aria-label="Close dialog"
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
      onKeyDown={(e) => {
        if (e.target === e.currentTarget && (e.key === 'Enter' || e.key === ' ')) onClose();
      }}
    >
      <div
        className="hh-modal"
        role="dialog"
        aria-modal="true"
        aria-label={project ? 'Edit project' : 'New project'}
      >
        <h2>{project ? 'Edit project' : 'New project'}</h2>

        <label className="hh-field" htmlFor="hh-project-title">
          <span>Title</span>
          <input
            id="hh-project-title"
            value={title}
            onChange={(e) => { setTitle(e.target.value); setTitleError(false); }}
            placeholder="e.g. Dog"
          />
          {titleError && <span className="hh-field-error">Title is required</span>}
        </label>

        <label className="hh-field" htmlFor="hh-project-description">
          <span>Description</span>
          <textarea
            id="hh-project-description"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows={2}
          />
        </label>

        <div className="hh-field">
          <span>Colour</span>
          <div className="hh-color-swatches">
            {PROJECT_COLORS.map((c) => (
              <button
                key={c}
                type="button"
                aria-label={`Choose colour ${c}`}
                className={`hh-color-swatch${c === color ? ' hh-color-swatch-selected' : ''}`}
                style={{ backgroundColor: c }}
                onClick={() => setColor(c)}
              />
            ))}
          </div>
        </div>

        <div className="hh-modal-actions">
          <button type="button" className="hh-btn hh-btn-secondary" onClick={onClose}>Cancel</button>
          <button type="button" className="hh-btn hh-btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}

export default ProjectDialog;
